import { Chip } from "@mui/material";
import { withTheme } from "@emotion/react";


const CITChip = (props) => {
    const theme = props.theme
    return  <Chip sx={{padding:'8px', borderRadius:'8px',border:"1px solid #98A2B3",height:'32px',...theme.typography.chip,'& .MuiChip-label':{padding:'0px'}}} label={props.label} variant="outlined" ></Chip>
}
export default withTheme(CITChip);